import React from 'react'

export function KpiSparkline({ history = [], width = 80, height = 24, direction = 'up' }) {
  if (history.length < 2) return null

  const values = history.map((h) => (typeof h.value === 'number' ? h.value : parseFloat(h.value) || 0))
  const min = Math.min(...values)
  const max = Math.max(...values)
  const range = max - min || 1

  const points = values.map((v, i) => {
    const x = (i / (values.length - 1)) * width
    const y = height - ((v - min) / range) * (height - 4) - 2
    return `${x},${y}`
  }).join(' ')

  const trend = values[values.length - 1] - values[0]
  const isGood = direction === 'down' ? trend <= 0 : trend >= 0
  const strokeColor = isGood ? '#3a8a5a' : '#c45a5a'

  return (
    <svg width={width} height={height} style={styles.svg}>
      <polyline
        points={points}
        fill="none"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  )
}

const styles = {
  svg: { display: 'block', flexShrink: 0 },
}
